import { render, staticRenderFns } from "./CreateWithdraw.vue?vue&type=template&id=40af539c&"
import script from "./CreateWithdraw.vue?vue&type=script&lang=js&"
export * from "./CreateWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports